import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  // eslint-disable-next-line consistent-return
  async getDataSources(params) {
    try {
      const response = await axios.get('uni/qbQuestionSets', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },
}
